import { buildURL } from "@comparaonline/cloudinary-image";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const style: StyleRulesCallback = ({ spacing }) => ({
  img: {
    display: "block",
    margin: "0 auto",
    maxWidth: spacing.unit * 65,
    padding: spacing.unit * 3,
    textAlign: "center" as React.CSSProperties["textAlign"],
    width: "100%"
  }
});

const skeletonSrc = buildURL("v1570822474/assets/placeholders/form-delightful/placeholder.svg");

export const LoadingFormDelightfulBase: React.FC<WithStyles<typeof style>> = ({ classes }) => (
  <img alt="" role="presentation" className={classes.img} src={skeletonSrc} />
);

const LoadingFormDelightful = withStyles(style)(LoadingFormDelightfulBase);

export { LoadingFormDelightful };
